import { getAllImageStore, setImageEntry, clearImageStore } from './indexedDBHelper';

export const addEmpIDToSession = async (empID, version) => {
  if (empID == '-1') return;

  const OrgDBName = localStorage.getItem("orgdbname");
  const id = String(empID);
  const newVersion = version ?? "-1";

  let imageStore = await getAllImageStore();

  const sample = Object.values(imageStore)[0];
  if (sample?.OrgDBName && sample.OrgDBName !== OrgDBName) {
    await clearImageStore();
    imageStore = {};
    localStorage.removeItem("OrgPhotoVersion");
  }

  const existingEntry = imageStore[id];
  if (existingEntry && existingEntry.imageUrl) {
    await setImageEntry({
      ...existingEntry,
      version: existingEntry.version,
      OrgDBName
    });
  } else {
    await setImageEntry({
      imgID: id,
      version: newVersion,
      imageUrl: null,
      OrgDBName
    });
  }
};

